exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-inventory-products-edit-kit .modal-dialog{min-height:450px}#modal-inventory-products-edit-kit .master-build-info{margin-bottom:1rem}#modal-inventory-products-edit-kit .master-build-info .alert{margin-bottom:0;font-size:.9rem}", ""]);

// exports
